import { name } from './name';
import { provider } from './provider';

export const columns = [name, provider];
